import React from "react";
import { profile, currently, metrics } from "../assets/content";
import { useCountUp } from "./hooks";
import photo from "../assets/photos/profilephoto.JPG";
import resume from "../assets/resume/Raed_Altaki_Resume_Senior_Backend_Engineer.pdf";

function Metric({ value, suffix, label }) {
  const [ref, current] = useCountUp(value);
  return (
    <div className="metric" ref={ref}>
      <div className="metric-value">
        {current}
        {suffix}
      </div>
      <div className="metric-label">{label}</div>
    </div>
  );
}

function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero-glow" aria-hidden="true"></div>
      <div className="container hero-grid">
        <div className="hero-text reveal">
          <div className="status-pill">
            <span className="status-dot"></span>
            {currently}
          </div>
          <h1>
            {profile.name}
            <span className="hero-role">{profile.title}</span>
          </h1>
          <p className="hero-lead">
            I build and run backend systems in C# and .NET: API integrations,
            sync platforms, and services that live in real customer
            environments. Design, code, review, and production support.
          </p>
          <div className="hero-meta">
            <span>
              <i className="fas fa-map-marker-alt"></i> {profile.location}
            </span>
            <span>
              <i className="fas fa-code"></i> {profile.focus}
            </span>
          </div>
          <div className="hero-actions">
            <a
              className="btn btn-primary"
              href={resume}
              download="Raed Altaki - Senior Backend Engineer - Resume.pdf"
            >
              <i className="fas fa-download"></i> Download resume
            </a>
            <a className="btn btn-ghost" href={`mailto:${profile.email}`}>
              <i className="fas fa-envelope"></i> Email me
            </a>
            <a
              className="icon-link"
              href={profile.linkedin}
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              className="icon-link"
              href={profile.github}
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub"
            >
              <i className="fab fa-github"></i>
            </a>
          </div>
        </div>
        <div className="hero-photo reveal">
          <div className="photo-ring">
            <img src={photo} alt={profile.name} />
          </div>
        </div>
      </div>
      <div className="container metrics reveal">
        {metrics.map((metric) => (
          <Metric key={metric.label} {...metric} />
        ))}
      </div>
    </section>
  );
}

export default Hero;
